export enum IdentifierStatus {
  Pending = 'PENDING',
  Verified = 'VERIFIED',
}
